<template>
  <div class="sms">
    <div class="sms__wrapper">
      <div class="sms__wrapper__header">
        <p class="title">Campaign editor</p>
        <p class="description">Set your sms targeted campaign details</p>
        <adx-breadcrumb class="breadcrumb" :items="items"/>
      </div>
      <div v-if="!isLoading" class="sms__wrapper__form">
        <!-- Iklan Page -->
        <div v-if="pageState == 1" class="sms__wrapper__form__iklan">
          <div class="sms__wrapper__form__iklan__id section">
            <adx-input :label="`Campaign Name *`" :value.sync="model.name" :ref="dataRef1.name" :error.sync="error.name" :validation="['NotEmpty', 'MaxLength:50']"/>
          </div>
          <div class="sms__wrapper__form__iklan__id section id">
            <adx-input :label="`ID Pengirim`" :value.sync="model.id" :disabled="true"/>
          </div>
          <div class="sms__wrapper__form__iklan__schedules section">
            <p class="section-title">Schedules</p>
            <div class="sms__wrapper__form__iklan__schedules__row">
              <div :class="['calendar', !dateStartInputted ? 'warning' : '']">
                <v-date-picker
                  v-model='model.startDate'
                  :min-date='today'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">Start Date</label>
                  </div>
                </v-date-picker>
              </div>
              <div :class="['calendar', !dateEndInputted ? 'warning' : '']">
                <v-date-picker
                  v-model='model.endDate'
                  :min-date='model.startDate > today ? model.startDate : today'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">End Date</label>
                  </div>
                </v-date-picker>
              </div>
            </div>
            <div class="sms__wrapper__form__iklan__schedules__row">
              <p v-if="!dateStartInputted || !dateEndInputted" class="error-message">Date must be inputted.</p>
            </div>
          </div>
        </div>
        <!-- Target Page -->
        <div v-if="pageState == 2" class="sms__wrapper__form__target">
          <div class="sms__wrapper__form__target__operator section">
            <p class="section-title">Phone Operator</p>
            <div class="sms__wrapper__form__target__operator__buttons">
              <div class="sms__wrapper__form__target__operator__buttons__row">
                <button :class="['btn-large', operator.ax ? 'primary' : 'secondary']" @click.stop="toggleBtn('ax')">Axis</button>
                <button :class="['btn-large', operator.tr ? 'primary' : 'secondary']" @click.stop="toggleBtn('tr')">Tri Indonesia</button>
                <button :class="['btn-large', operator.in ? 'primary' : 'secondary']" @click.stop="toggleBtn('in')">Indosat Ooredoo</button>
              </div>
              <div class="sms__wrapper__form__target__operator__buttons__row">
                <button :class="['btn-large', operator.sm ? 'primary' : 'secondary']" @click.stop="toggleBtn('sm')">Smartfen</button>
                <button :class="['btn-large', operator.te ? 'primary' : 'secondary']" @click.stop="toggleBtn('te')">Telkomsel</button>
                <button :class="['btn-large', operator.xl ? 'primary' : 'secondary']" @click.stop="toggleBtn('xl')">XL Axiata</button>
              </div>
            </div>
            <p v-if="!operatorInputted" class="error-message">Please select at least one operator.</p>
          </div>
          <div class="sms__wrapper__form__target__location section">
            <p class="section-title">Location</p>
            <adx-single-search-dropdown :label="`Choose targeted location`" :optionsParam="locationDropdown" :class="['dropdown', !locationInputted ? 'warning' : '']" :value.sync="model.locationTarget"/>
            <p v-if="!locationInputted" class="error-message">Please select a location.</p>
          </div>
          <div class="sms__wrapper__form__target__interest section">
            <p class="section-title">Interest</p>
            <adx-select-dropdown :label="`Choose audience interest`" :options="interestDropdown" :class="['dropdown', !interestInputted ? 'warning' : '']" :value.sync="model.interest"/>
            <p v-if="!interestInputted" class="error-message">Please select an interest.</p>
          </div>
          <div class="sms__wrapper__form__target__message section">
            <p class="section-title">Message</p>
            <adx-textarea :label="`Your message max 160 characters *`" :value.sync="model.message" :error.sync="error.message" :ref="dataRef2.message" :class="['textarea', !messageInputted ? 'warning' : '']" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:160']"/>
            <p v-if="!messageInputted" class="error-message">Please write some messages.</p>
          </div>
        </div>
        <!-- Budget Page -->
        <div v-if="pageState == 3" class="sms__wrapper__form__budget">
          <div class="sms__wrapper__form__budget__packages section">
            <p class="section-title">SMS blast packages</p>
            <div class="sms__wrapper__form__budget__packages__radio-wrapper">
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="one" :value="packageOption[0].id" v-model="model.package"/>
                  <label class="subhead" for="one">{{ packageOption[0].price| formatMoney }}</label>
                </div>
                <p class="description">{{ packageOption[0].quantity }} SMS Blast All national number</p>
              </div>
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="two" :value="packageOption[1].id" v-model="model.package"/>
                  <label class="subhead" for="two">{{ packageOption[1].price| formatMoney }}</label>
                </div>
                <p class="description">{{ packageOption[1].quantity }} SMS Blast All national number</p>
              </div>
            </div>
            <div class="sms__wrapper__form__budget__packages__radio-wrapper">
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="three" :value="packageOption[2].id" v-model="model.package"/>
                  <label class="subhead" for="three">{{ packageOption[2].price| formatMoney }}</label>
                </div>
                <p class="description">{{ packageOption[2].quantity }} SMS Blast All national number</p>
              </div>
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="four" :value="packageOption[3].id" v-model="model.package"/>
                  <label class="subhead" for="four">{{ packageOption[3].price| formatMoney }}</label>
                </div>
                <p class="description">{{ packageOption[3].quantity }} Blast All national number</p>
              </div>
            </div>
            <p v-if="!packageInputted" class="error-message">Please select at least one package.</p>
          </div>
          <div class="sms__wrapper__form__budget__promo section">
            <div class="sms__wrapper__form__budget__promo__header">
              <span class="strong subhead">Promo Code</span>
            </div>
            <div v-if="!isPromoCodeValid" class="sms__wrapper__form__budget__promo__fields">
              <adx-input :button="`Use`" :label="`Input Promo Code`" :error.sync="promoCodeError" :value.sync="promoCode" @buttonClicked="useVoucher" :upperCase="true"/>
            </div>
            <div v-else class="sms__wrapper__form__budget__promo__fields">
              <div if class="sms__wrapper__form__budget__promo__fields__dialog">
                <div class="sms__wrapper__form__budget__promo__fields__dialog__button">
                  <i class="adx-ic_close" @click="unuseVoucher"></i>
                </div>
                <div class="sms__wrapper__form__budget__promo__fields__dialog__header">
                  <span>Kode Promo: </span>
                  <span class="code">{{promoCode}}</span>
                </div>
                <div class="sms__wrapper__form__budget__promo__fields__dialog__description">
                  <span>
                    Congrats! you get discount - {{discount | formatMoney}} for this transaction
                  </span>
                </div>
              </div>
              <span v-if="promoCodeError" class="sms__wrapper__form__budget__promo__error"> {{promoCodeError}} </span>
            </div>
            <div class="payment__clear-both"></div>
          </div> 
          <div v-if="promoNominal" class="sms__wrapper__form__budget__promo section">
            <div class="sms__wrapper__form__budget__promo__header">
              <span class="strong subhead">Total Price : {{ discountedPrice | formatMoney }}</span>
            </div>
            <p>*This is price you need to pay after discount</p>
          </div>
          <div class="sms__wrapper__form__budget__notes section">
            <p class="section-title">Additional Notes and Comments</p>
            <adx-textarea :label="`Your message max 200 characters`" :value.sync="model.notes" :validation="['MaxLength:200']"/>
          </div>
        </div>
        <div class="sms__wrapper__form__buttons">
          <button v-if="pageState != 1" class="btn-large secondary" @click.stop="prev" :disabled="isSubmitting">Previous</button>
          <button v-if="pageState < 3" class="btn-large primary" @click.stop="next">Continue</button>
          <button v-else class="btn-large primary" @click.stop="submit" :disabled="isSubmitting">Submit<adx-loading-circle class="loading" v-if="isSubmitting" slot="loading" /></button>
        </div>
      </div>
      <adx-loading v-else slot="loading" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Textarea from '@/components/Form/TextArea'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import Loading from '@/components/Loading/Primary'
import LoadingCircle from '@/components/Loading/Secondary-white'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment';
import calendar from 'v-calendar'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-digitaladvertising-smstargeted',
  components: {
    'adx-breadcrumb': Breadcrumb,
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-select-dropdown': SelectDropdown,
    'adx-textarea': Textarea,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-loading': Loading,
    'adx-loading-circle': LoadingCircle,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      pageState: 1,
      items: [
        {
          'id': 0,
          'title': '1. Iklan',
          'isCurrent': true
        },
        {
          'id': 1,
          'title': '2. Target',
          'isCurrent': false
        },
        {
          'id': 2,
          'title': '3. Budget',
          'isCurrent': false
        },
      ],
      model: {
        name: '',
        id: 'Smart UKM',
        startDate: null,
        endDate: null,
        message: '',
        operator: [],
        locationTarget: 'Ambon',
        interest: 'Business and industry',
        package: 1,
        notes: ''
      },
      dataRef1: {
        name: 'name'
      },
      dataRef2: {
        message: 'message'
      },
      error: {
        name: '',
        message: ''
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      operator: {
        ax: true,
        tr: false,
        in: false,
        sm: false,
        te: false,
        xl: false,
      },
      test: false,
      selectedLocationValue: [],
      packageOption: [],
      isLoading: false,
      isSubmitting: false,
      isValidationPassed: false,
      dateInputted: true,
      dateStartInputted: true,
      dateEndInputted: true,
      operatorInputted: true,
      locationInputted: true,
      interestInputted: true,
      messageInputted: true,
      packageInputted: true,
      promoCode: '',
      discount: 0,
      promoNominal: 0,
      isPromoCodeValid: false,
      promoCodeError: '',
      interestDropdown: [
        {
          label: 'Business and industry',
          value: 'Business and industry'
        },
        {
          label: 'Entertainment',
          value: 'Entertainment'
        },
        {
          label: 'Family and relationships',
          value: 'Family and relationships'
        },
        {
          label: 'Fitness and wellness',
          value: 'Fitness and wellness'
        },
        {
          label: 'Food and drink',
          value: 'Food and drink'
        },
        {
          label: 'Hobbies and activities',
          value: 'Hobbies and activities'
        },
        {
          label: 'Shopping and fashion',
          value: 'Shopping and fashion'
        },
        {
          label: 'Sports and outdoors',
          value: 'Sports and outdoors'
        },
        {
          label: 'Technology',
          value: 'Technology'
        },
      ],
      locationDropdown: [
        {
          label: 'Ambon',
          value: 'Ambon'
        },
        {
          label: 'Amlapura',
          value: 'Amlapura'
        },
        {
          label: 'Amuntai',
          value: 'Amuntai'
        },
        {
          label: 'Bali',
          value: 'Bali'
        },
        {
          label: 'Balikpapan',
          value: 'Balikpapan'
        },
        {
          label: 'Banda Aceh',
          value: 'Banca Aceh'
        },
        {
          label: 'Bandar Lampung',
          value: 'Bandar Lampung'
        },
        {
          label: 'Bandung',
          value: 'Bandung'
        },
        {
          label: 'Bangko',
          value: 'Bangko'
        },
        {
          label: 'Banjarmasin',
          value: 'Banjarmasin'
        },
        {
          label: 'Banjar Negara',
          value: 'Banjar Negara'
        },
        {
          label: 'Bantul',
          value: 'Bantul'
        },
        {
          label: 'Banyumas',
          value: 'Banyumas'
        },
        {
          label: 'Banyuwangi',
          value: 'Banyuwangi'
        },
        {
          label: 'Barabai',
          value: 'Barabai'
        },
        {
          label: 'Batam',
          value: 'Batam'
        },
        {
          label: 'Batang',
          value: 'Batang'
        },
        {
          label: 'Baturaja',
          value: 'Baturaja'
        },
        {
          label: 'Baubau',
          value: 'Baubau'
        },
        {
          label: 'Bekasi',
          value: 'Bekasi'
        },
        {
          label: 'Bengkulu',
          value: 'Bengkulu'
        },
        {
          label: 'Bengkulu',
          value: 'Bengkulu'
        },
        {
          label: 'Biak',
          value: 'Biak'
        },
        {
          label: 'Bima',
          value: 'Bima'
        },
        {
          label: 'Bitung',
          value: 'Bitung'
        },
        {
          label: 'Blitar',
          value: 'Blitar'
        },
        {
          label: 'Blora',
          value: 'Blora'
        },
        {
          label: 'Bogor',
          value: 'Bogor'
        },
        {
          label: 'Bojonegoro',
          value: 'Bojonegoro'
        },
        {
          label: 'Bontang',
          value: 'Bontang'
        },
        {
          label: 'Boyolali',
          value: 'Boyolali'
        },
        {
          label: 'Brebes',
          value: 'Brebes'
        },
        {
          label: 'Bukit Tinggi',
          value: 'Bukit Tinggi'
        },
        {
          label: 'Cianjur',
          value: 'Cianjur'
        },
        {
          label: 'Cilacap',
          value: 'Cilacap'
        },
        {
          label: 'Cirebon',
          value: 'Cirebon'
        },
        {
          label: 'Curup',
          value: 'Curup'
        },
        {
          label: 'Demak',
          value: 'Demak'
        },
        {
          label: 'Denpasar',
          value: 'Denpasar'
        },
        {
          label: 'Depok',
          value: 'Depok'
        },
        {
          label: 'Donggala',
          value: 'Donggala'
        },
        {
          label: 'Dumai',
          value: 'Dumai'
        },
        {
          label: 'Garut',
          value: 'Garut'
        },
        {
          label: 'Gorontalo',
          value: 'Gorontalo'
        },
        {
          label: 'Grobogan',
          value: 'Grobogan'
        },
        {
          label: 'Gunung Kidul',
          value: 'Gunung Kidul'
        },
        {
          label: 'Indramayu',
          value: 'Indramayu'
        },
        {
          label: 'Jakarta',
          value: 'Jakarta'
        },
        {
          label: 'Jambi',
          value: 'Jambi'
        },
        {
          label: 'Jayapura',
          value: 'Jayapura'
        },
        {
          label: 'Jember',
          value: 'Jember'
        },
        {
          label: 'Jepara',
          value: 'Jepara'
        },
        {
          label: 'Kabanjahe',
          value: 'Kabanjahe'
        },
        {
          label: 'Karang Anyar',
          value: 'Karang Anyar'
        },
        {
          label: 'Kayuagung',
          value: 'Kayuagung'
        },
        {
          label: 'Kayuagung',
          value: 'Kayuagung'
        },
        {
          label: 'Kebumen',
          value: 'Kebumen'
        },
        {
          label: 'Kediri',
          value: 'Kediri'
        },
        {
          label: 'Kendal',
          value: 'Kendal'
        },
        {
          label: 'Kendari',
          value: 'Kendari'
        },
        {
          label: 'Kerawang',
          value: 'Kerawang'
        },
        {
          label: 'Ketapang Kalimantan',
          value: 'Ketapang Kalimantan'
        },
        {
          label: 'Kisaran',
          value: 'Kisaran'
        },
        {
          label: 'Klaten',
          value: 'Klaten'
        },
        {
          label: 'Kolaka',
          value: 'Kolaka'
        },
        {
          label: 'Kotabaru',
          value: 'Kotabaru'
        },
        {
          label: 'Kotabumi',
          value: 'Kotabumi'
        },
        {
          label: 'Kotamobagu',
          value: 'Kotamobagu'
        },
        {
          label: 'Krui',
          value: 'Krui'
        },
        {
          label: 'Kualakapuas',
          value: 'Kualakapuas'
        },
        {
          label: 'Kualatungkal',
          value: 'Kualatungkal'
        },
        {
          label: 'Kudus',
          value: 'Kudus'
        },
        {
          label: 'Kupang',
          value: 'Kupang'
        },
        {
          label: 'Lahat',
          value: 'Lahat'
        },
        {
          label: 'Langsa',
          value: 'Langsa'
        },
        {
          label: 'Lhokseumawe',
          value: 'Lhokseumawe'
        },
        {
          label: 'Liwa',
          value: 'Liwa'
        },
        {
          label: 'Lubuk Linggau',
          value: 'Lubuk Linggau'
        },
        {
          label: 'Lumajang',
          value: 'Lumajang'
        },
        {
          label: 'Madiun',
          value: 'Madiun'
        },
        {
          label: 'Magelang',
          value: 'Magelang'
        },
        {
          label: 'Majalengka',
          value: 'Majalengka'
        },
        {
          label: 'Makassar',
          value: 'Makassar'
        },
        {
          label: 'Malang',
          value: 'Malang'
        },
        {
          label: 'Manado',
          value: 'Manado'
        },
        {
          label: 'Manokwari',
          value: 'Manokwari'
        },
        {
          label: 'Mataram',
          value: 'Mataram'
        },
        {
          label: 'Medan',
          value: 'Medan'
        },
        {
          label: 'Menggala',
          value: 'Menggala'
        },
        {
          label: 'Merauke',
          value: 'Merauke'
        },
        {
          label: 'Metro',
          value: 'Metro'
        },
        {
          label: 'Meulaboh',
          value: 'Meulaboh'
        },
        {
          label: 'Mojokerto',
          value: 'Mojokerto'
        },
        {
          label: 'Muara Bungo',
          value: 'Muara Bungo'
        },
        {
          label: 'Muara Enim',
          value: 'Muara Enim'
        },
        {
          label: 'Muara Teweh',
          value: 'Muara Teweh'
        },
        {
          label: 'Muntok',
          value: 'Muntok'
        },
        {
          label: 'Negara',
          value: 'Negara'
        },
        {
          label: 'Nganjuk',
          value: 'Nganjuk'
        },
        {
          label: 'Pacitan',
          value: 'Pacitan'
        },
        {
          label: 'Padang',
          value: 'Padang'
        },
        {
          label: 'Padang Sidempuan',
          value: 'Padang Sidempuan'
        },
        {
          label: 'Pekanbaru',
          value: 'Pekanbaru'
        },
        {
          label: 'Palangkaraya',
          value: 'Palangkaraya'
        },
        {
          label: 'Palembang',
          value: 'Palembang'
        },
        {
          label: 'Palu',
          value: 'Palu'
        },
        {
          label: 'Pamekasan',
          value: 'Pamekasan'
        },
        {
          label: 'Pandeglang',
          value: 'Pandeglang'
        },
        {
          label: 'Pangkalan Brandan',
          value: 'Pangkalan Brandan'
        },
        {
          label: 'Pangkalan Bun',
          value: 'Pangkalan Bun'
        },
        {
          label: 'Pangkal Pinang',
          value: 'Pangkal Pinang'
        },
        {
          label: 'Pare Pare',
          value: 'Pare Pare'
        },
        {
          label: 'Pasuruan',
          value: 'Pasuruan'
        },
        {
          label: 'Pati',
          value: 'Pati'
        },
        {
          label: 'Pekalongan',
          value: 'Pekalongan'
        },
        {
          label: 'Pemalang',
          value: 'Pemalang'
        },
        {
          label: 'Pematang Siantar',
          value: 'Pematang Siantar'
        },
        {
          label: 'Pleihari',
          value: 'Pleihari'
        },
        {
          label: 'Ponorogo',
          value: 'Ponorogo'
        },
        {
          label: 'Pontianak',
          value: 'Pontianak'
        },
        {
          label: 'Prabumulih',
          value: 'Prabumulih'
        },
        {
          label: 'Pringsewu',
          value: 'Pringsewu'
        },
        {
          label: 'Probolinggo',
          value: 'Probolinggo'
        },
        {
          label: 'Purbalingga',
          value: 'Purbalingga'
        },
        {
          label: 'Purwakarta',
          value: 'Purwakarta'
        },
        {
          label: 'Purwodadi',
          value: 'Purwodadi'
        },
        {
          label: 'Purwokerto',
          value: 'Purwokerto'
        },
        {
          label: 'Purworejo',
          value: 'Purworejo'
        },
        {
          label: 'Rangkas Bitung',
          value: 'Rangkas Bitung'
        },
        {
          label: 'Rantau Prapat',
          value: 'Rantau Prapat'
        },
        {
          label: 'Rantepao',
          value: 'Rantepao'
        },
        {
          label: 'Rembang',
          value: 'Rembang'
        },
        {
          label: 'Rengat',
          value: 'Rengat'
        },
        {
          label: 'Sabang',
          value: 'Sabang'
        },
        {
          label: 'Salatiga',
          value: 'Salatiga'
        },
        {
          label: 'Samarinda',
          value: 'Samarinda'
        },
        {
          label: 'Sampang',
          value: 'Sampang'
        },
        {
          label: 'Sampit',
          value: 'Sampit'
        },
        {
          label: 'Sekayu',
          value: 'Sekayu'
        },
        {
          label: 'Selong',
          value: 'Selong'
        },
        {
          label: 'Semarang',
          value: 'Semarang'
        },
        {
          label: 'Serang',
          value: 'Serang'
        },
        {
          label: 'Sibolga',
          value: 'Sibolga'
        },
        {
          label: 'Sigli',
          value: 'Sigli'
        },
        {
          label: 'Singaraja',
          value: 'Singaraja'
        },
        {
          label: 'Singkawang',
          value: 'Singkawang'
        },
        {
          label: 'Sintang',
          value: 'Sintang'
        },
        {
          label: 'Situ Bondo',
          value: 'Situ Bondo'
        },
        {
          label: 'Solo',
          value: 'Solo'
        },
        {
          label: 'Soroako',
          value: 'Soroako'
        },
        {
          label: 'Sorong',
          value: 'Sorong'
        },
        {
          label: 'Sragen',
          value: 'Sragen'
        },
        {
          label: 'Subang',
          value: 'Subang'
        },
        {
          label: 'Sukabumi',
          value: 'Sukabumi'
        },
        {
          label: 'Sukoharjo',
          value: 'Sukoharjo'
        },
        {
          label: 'Sumbawa Besar',
          value: 'Sumbawa Besar'
        },
        {
          label: 'Sumedang',
          value: 'Sumedang'
        },
        {
          label: 'Sumenep',
          value: 'Sumenep'
        },
        {
          label: 'Surabaya',
          value: 'Surabaya'
        },
        {
          label: 'Tangerang',
          value: 'Tangerang'
        },
        {
          label: 'Tanjung Balai Karimun',
          value: 'Tanjung Balai Karimun'
        },
        {
          label: 'Tanjung Karang',
          value: 'Tanjung Karang'
        },
        {
          label: 'Tanjung Pandan',
          value: 'Tanjung Pandan'
        },
        {
          label: 'Tanjung Tabalong',
          value: 'Tanjung Tabalong'
        },
        {
          label: 'Tarakan',
          value: 'Tarakan'
        },
        {
          label: 'Tasikmalaya',
          value: 'Tasikmalaya'
        },
        {
          label: 'Tebing Tinggi Deli',
          value: 'Tebing Tinggi Deli'
        },
        {
          label: 'Tegal',
          value: 'Tegal'
        },
        {
          label: 'Teluk Betung',
          value: 'Teluk Betung'
        },
        {
          label: 'Temanggung',
          value: 'Temanggung'
        },
        {
          label: 'Tembilahan',
          value: 'Tembilahan'
        },
        {
          label: 'Ternate',
          value: 'Ternate'
        },
        {
          label: 'Timika',
          value: 'Timika'
        },
        {
          label: 'Tuban',
          value: 'Tuban'
        },
        {
          label: 'Tulung Agung',
          value: 'Tulung Agung'
        },
        {
          label: 'Wonogiri',
          value: 'Wonogiri'
        },
        {
          label: 'Wonosobo',
          value: 'Wonosobo'
        },
        {
          label: 'Yogyakarta',
          value: 'Yogyakarta'
        },
      ],
    }
  },
  computed: {
    today() {
      var today = new Date();
      today.setDate(today.getDate() + 7)
      return today
    },
    discountedPrice() {
      let budget = this.packageOption.filter(value => { return value.id == this.model.package})[0]
      var price = parseInt(budget.price) - this.promoNominal
      if (price < 0) return 0
      return price
    }
  },
  watch: {
    promoCode: function () {
      this.promoCode = this.promoCode.toUpperCase()
    },
    'operator.ax': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
    'operator.tr': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
    'operator.in': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
    'operator.sm': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
    'operator.te': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
    'operator.xl': function () {
      this.$nextTick(() => {
        this.validateCheckboxes()
      });
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
    this.setDateValue()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    useVoucher() {
      (async () => {
        this.promoCodeError = ''
        this.discount -= this.promoNominal
        let params = {
          voucher_code: this.promoCode
        }
        const response = await api.get(apiV2.checkVoucher, { needToken: true, params: params })
        if (response.status == 200) {
          this.promoNominal = response.data.nominal
          this.discount += response.data.nominal
          // let budget = this.packageOption.filter(value => { return value.id == this.model.package})[0]
          // if (parseInt(budget.price) <= this.promoNominal) {
          //   this.promoNominal = parseInt(parseInt(budget.price))
          //   this.discount = parseInt(parseInt(budget.price))
          // } 
          // else if (this.totalPrice < 9999 ) {
          //   this.promoCodeError = 'Total price should not be be between Rp 0 and Rp 10.000'
          //   this.loadingMidTrans = true
          // } 
          this.isPromoCodeValid = true
        } else {
          this.isPromoCodeValid = false
          this.promoCodeError = response.data.message
        }
      })();
    },
    unuseVoucher() {
      this.isPromoCodeValid = false
      this.discount -= this.promoNominal
      this.promoNominal = 0
    },
    setDateValue() {
      var dateValue = new Date()
      var dateValue1 = new Date()
      dateValue.setDate(dateValue.getDate() + 7)
      dateValue1.setDate(dateValue1.getDate() + 8)
      this.model.startDate = dateValue
      this.model.endDate = dateValue1
    },
    nextPage() {
      this.items[this.pageState - 1].isCurrent = false
      this.pageState += 1
      this.items[this.pageState - 1].isCurrent = true
    },
    next() {
      this.raiseError(this.pageState)
      if (this.pageState == 2) {
        if (this.isValidationPassed) {
          if (this.operatorInputted) this.nextPage()
        }
      } else {
        if (this.isValidationPassed) this.nextPage()
      }
    },
    raiseError(page) {
      var validationObj = {}
      if (page == 1) {
        validationObj = this.dataRef1
      } else if (page == 2) {
        validationObj = this.dataRef2
      }
      for (let key in validationObj) {
        let value = this.$refs[key].value
        let element = this.$refs[key].$el.firstElementChild
        if (!value || this.error[key] != false) {
          element.focus()
          element.blur()
          this.isValidationPassed = false
          break
        } else {
          this.isValidationPassed = true
        }
      }
    },
    prev() {
      if (this.pageState > 1) {
        this.items[this.pageState - 1].isCurrent = false
        this.pageState -= 1
        this.items[this.pageState - 1].isCurrent = true
      }
    },
    submit() {
      if (!this.model.package) {
        this.packageInputted = false
        return
      } else {
        this.packageInputted = true
      }
      Object.keys(this.operator).map(key => {
        if (key == 'ax' && this.operator[key]) {
          this.model.operator.push('Axis')
        } else if (key == 'tr' && this.operator[key]) {
          this.model.operator.push('Tri')
        } else if (key == 'in' && this.operator[key]) {
          this.model.operator.push('Indosat Ooredoo')
        } else if (key == 'sm' && this.operator[key]) {
          this.model.operator.push('SmartFren')
        } else if (key == 'te' && this.operator[key]) {
          this.model.operator.push('Telkomsel')
        } else if (key == 'xl' && this.operator[key]) {
          this.model.operator.push('XL Axiata')
        }
      });
      
      (async () => {
        this.isSubmitting = true
        let data = {
          detail: {
            sender: this.model.id,
            start_date: this.model.startDate,
            end_date: this.model.endDate,
            message: this.model.message
          },
          target: {
            operator: this.model.operator,
            location_target: this.model.locationTarget,
            interest: this.model.interest,
            notes: this.model.notes,
            campaign_name: this.model.name
          },
          package: this.model.package,
          promo: {
            code: this.promoCode,
            nominal: this.promoNominal
          }
        }
        const response = await api.post(apiV2.smsTarget, data, { needToken: true })
        if (response.status == 201) {
          this.$notify({
            group: 'saved',
            title: 'Save success',
            text: 'Data successfully saved!',
            type: 'success'
          });
          this.$router.push({name: 'transactiondigitaladvertising'})
        } else {
          this.$notify({
            group: 'saved',
            title: 'Save error',
            text: 'Oops data can not be saved!',
            type: 'danger'
          });
        }
        this.isSubmitting = false
      })();
    },
    toggleBtn(key) {
      this.operator[key] = !this.operator[key]
    },
    validateCheckboxes() {
      let isOperatorEmpty = []
      Object.keys(this.operator).map(key => {
        if (this.operator[key]) isOperatorEmpty.push(true)
      });
      !isOperatorEmpty.length ? this.operatorInputted = false : this.operatorInputted = true
    },
    initialLoad() {
      (async () => {
        this.isLoading = true
        let params = {
          type: 'ta'
        }
        const response = await api.get(apiV2.smsPackage, { params: params, needToken: true})
        if (response.status == 200) {
          const { data } = response
          data.map(obj => {
            this.packageOption.push(obj)
          })
        }
        this.isLoading = false
      })();
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.selectDropdown {

  .select {
    .standardInput {
      padding: 16px !important;
    }
  }

  .popup {
    max-height: 300px;
    overflow-y: auto !important;
  }
}

.small-title {
  font-size: 15px;
  font-weight: normal !important;

  &.current {
    font-weight: bold !important;
  }
}
.id {
  .input{
    input {
      color: #999999 !important;
    }
  }
}
</style>